export default class ProfileMenuController {
  constructor($element, $document, $scope, $state, Auth) {
    'ngInject'

    this.element = $element[0];
    this.$document = $document;
    this.$scope = $scope;
    this.$state = $state;
    this.Auth = Auth;
  }

  $onInit() {
    this.Auth.getCurrentUser().then((user) => {
      this.currentUser = user;
    });
  }

  $postLink() {
    this.handleHidding();
  }

  handleHidding() {
    const clickEvent = 'click';
    this.$document.on(clickEvent, (event) => {
      if (!this.opened) {
        return;
      }

      if (event.target === this.element || this.element.contains(event.target)) {
        return;
      }
      this.opened = false;
      this.$scope.$apply();
    });
  }

  logout() {
    this.Auth.logout().then((user) => {
      this.$state.go('landing');
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/profile-menu/profile-menu.controller.js